import type { IconProps } from "./icon-types";

/**
 * 원 안 X — error/실패 상태 표시. `CloseIcon`(bare)의 원 두른 변형.
 * Toast error tone 등 status 표현에서 공용.
 */
export const CloseCircleIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <circle cx="8" cy="8" r="6" />
    <path d="M5.8 5.8l4.4 4.4M10.2 5.8l-4.4 4.4" />
  </svg>
);
